import "../../styles/dashboard.css";

const ADMIN_ITEMS = [
  
  {
    key: "inventory",
    label: "Seized vehicles Details",
    statKey: "inventoryConfirmed",
    icon: "🚘",
    desc: "Seized vehicles in inventory",
  },
  {
    key: "pending",
    label: "Pending confirmations",
    statKey: "pendingConfirmations",
    icon: "⏳",
    desc: "Review pending field confirmations",
  },
  {
    key: "confirmations",
    label: "Confirmed cases",
    statKey: "confirmations",
    icon: "✅",
    desc: "View confirmed vehicle traces",
  },
  {
    key: "records",
    label: "Uploaded records",
    statKey: "cases",
    icon: "📁",
    desc: "Agency uploaded repo records",
  },
];

const FIELD_USER_ITEMS = [
  {
    key: "pending",
    label: "Pending confirmations",
    statKey: "pendingConfirmations",
    icon: "⏳",
    desc: "Review pending field confirmations",
  },
  {
    key: "confirmations",
    label: "Confirmed cases",
    statKey: "confirmations",
    icon: "✅",
    desc: "View confirmed vehicle traces",
  },
  {
    key: "inventory",
    label: "Seized vehicles Details",
    statKey: "inventoryConfirmed",
    icon: "🚘",
    desc: "Seized vehicles in inventory",
  },
];

export default function DashboardStatsBar({
  stats = {},
  loading,
  activeKey,
  onStatClick,
  className = "",
  trailingItems = [],
  items: itemsProp,
  variant = "admin",
}) {
  const baseItems = variant === "field" ? FIELD_USER_ITEMS : ADMIN_ITEMS;
  const items = itemsProp
    ? itemsProp
    : [
        ...baseItems.map((item) => ({
          key: item.key,
          label: item.label,
          icon: item.icon,
          desc: item.desc,
          value: stats[item.statKey] ?? 0,
        })),
        ...trailingItems,
      ];

  const barClass =
    variant === "field"
      ? "stats stats-single-row dashboard-stats-bar dashboard-stats-bar--field-user home-starter-cards"
      : "stats stats-single-row dashboard-stats-bar";

  return (
    <div className={`${barClass} ${className}`.trim()}>
      {items.map((item) => {
        const clickable = typeof onStatClick === "function";
        const active = activeKey === item.key;
        const Tag = clickable ? "button" : "div";

        return (
          <Tag
            key={item.key}
            type={clickable ? "button" : undefined}
            className={`stat card action-card dashboard-action-card dashboard-stat-card${
              active ? " stat--active" : ""
            }${clickable ? " stat--clickable" : ""}`}
            onClick={clickable ? () => onStatClick(item.key) : undefined}
          >
            {item.icon ? <div className="action-icon">{item.icon}</div> : null}
            <div className="stat-value">{loading ? "…" : item.value}</div>
            <h4 className="stat-label">{item.label}</h4>
            {item.desc ? <p className="muted small">{item.desc}</p> : null}
          </Tag>
        );
      })}
    </div>
  );
}
